import { Collection, CollectionBannerWidth } from '@app/features/collections/models/collection';

export const cameoGreen: Collection = {
  id: 's-and-p-cameo-green',
  brandId: 'salt-and-pepper',
  brandName: 'Salt and Pepper',
  icon: 'logo_salt_pepper.png',
  title: 'Cameo Groen',
  subTitle: 'Nieuw Collectie',
  banner: 'cameo-green/Cameo_green_01-banner.jpg',
  items: [
    {
      id: 's-and-p-cameo-green-1',
      collectionImages: [
        {
          image: 'cameo-green/Cameo_green_aura_essenza_01.jpg',
          width: CollectionBannerWidth['25%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'cameo-green/Cameo_green_02.jpg',
          width: CollectionBannerWidth['75%'],
          fullHeight: false,
          items: [
            { left: '45%', top: '70%', salesArticleId: '469cec00-a76e-42f2-96e1-947add9346b2' },
            { left: '60%', top: '65%', salesArticleId: '29ec9cad-0d0d-41de-8314-601c504a250f' },
            { left: '52%', top: '57%', salesArticleId: '184e031e-d3c1-4bea-8222-10530fef654c' },
            { left: '34%', top: '60%', salesArticleId: '196b4a37-5ac3-4886-a745-b20296e74c9e' },
            { left: '25%', top: '55%', salesArticleId: '814e043b-43f8-4f82-bf5f-e37508062b6a' },
            { left: '25%', top: '45%', salesArticleId: 'c2f1a7b5-a5bd-48e6-a606-82fc50358942' },
            { left: '34%', top: '50%', salesArticleId: '2d359a2b-a79a-43ac-8532-10dd074d565f' },
            { left: '44%', top: '50%', salesArticleId: '307fae89-e30c-4504-aa08-12ea75572e46' },
            { left: '75%', top: '55%', salesArticleId: '97c7cd6b-f749-4158-929b-d9c293fd654a' },
            { left: '85%', top: '55%', salesArticleId: 'd8b5e98e-04b6-418d-858f-f207c49421f4' },
            { left: '67%', top: '57%', salesArticleId: 'd7ef0e63-7f63-4373-9cea-25f5f2590617' },
            { left: '67%', top: '45%', salesArticleId: '4b953cce-e239-486f-b4c7-84d1aa4c0a90' }
          ]
        }
      ]
    },
    {
      id: 's-and-p-cameo-green-2',
      collectionImages: [
        {
          image: 'cameo-green/Cameo_green_essenza_grind_prisma_01.jpg',
          width: CollectionBannerWidth['100%'],
          fullHeight: true,
          items: []
        }
      ]
    },
    {
      id: 's-and-p-cameo-green-3',
      collectionImages: [
        { image: 'cameo-green/Cameo_green_04.jpg', width: CollectionBannerWidth['25%'], fullHeight: false },
        { image: 'cameo-green/Cameo_green_aura_02.jpg', width: CollectionBannerWidth['75%'], fullHeight: false }
      ]
    }
  ],
  salesArticleIds: [
    '469cec00-a76e-42f2-96e1-947add9346b2',
    'db89597b-d77f-4877-be4a-25ad1b16b8b5',
    '35b25b00-8a91-4fd9-87f2-4f2175002c56',
    '196b4a37-5ac3-4886-a745-b20296e74c9e',
    'd8b5e98e-04b6-418d-858f-f207c49421f4',
    '29ec9cad-0d0d-41de-8314-601c504a250f',
    'c2f1a7b5-a5bd-48e6-a606-82fc50358942',
    '814e043b-43f8-4f82-bf5f-e37508062b6a',
    '97c7cd6b-f749-4158-929b-d9c293fd654a',
    'ebfe0dc5-fd8d-4942-9936-8ca3c1a14fc5',
    '48a957b1-7f2c-4987-97d2-cbfa6c4a4139',
    '307fae89-e30c-4504-aa08-12ea75572e46',
    'f6451ec9-4a1f-426a-b1e7-7804ec42bd2c',
    '2953579c-79ac-4733-8d24-374d856f7d99',
    'd7ef0e63-7f63-4373-9cea-25f5f2590617',
    '1f41f3ea-07c2-4614-b243-2127181370d8',
    '184e031e-d3c1-4bea-8222-10530fef654c',
    '3d7c3178-5134-4ae7-b2ef-6585f690b68b',
    '4b953cce-e239-486f-b4c7-84d1aa4c0a90',
    '2d359a2b-a79a-43ac-8532-10dd074d565f',
    'c221a5c0-b20b-43bc-a909-744f99574abd',
    '1e76f15b-bd43-4791-a7f5-4357e3a29fb7'
  ]
};
